export const ColorModel = {
    color_id: 0,
    hex_code : ""
}